import { CommonFunctions } from "../static/common-functions";
import { BaseBus } from './BaseBus';
import { TimeOffEntry } from "./TimeOffEntry";

export class PersonSel extends BaseBus
{
    constructor(busObj: PersonSel = null) {
        super(busObj);
        if (CommonFunctions.hasArrayValue(this.timeOff)) {
            let arr: TimeOffEntry[] = [];
            for (let i = 0; i < busObj.timeOff.length; i++) {
                arr.push(new TimeOffEntry(busObj.timeOff[i]));
            }
            this.timeOff = arr;
        }
        this.empName = this.empNo + ' - ' + this.description;
    }
    value: any;
    category: any;
    userId: any;
    description: string;
    isActive: boolean;
    jobRoleId: any;
    timeOff: TimeOffEntry[];
    empNo: string;
    empName: string;
    //public get empName(): string {
    //    return this.empNo + ' - ' + this.description;
    //}
 
}